import TrainerAvatar from './TrainerAvatar.jsx';

export default TrainerAvatar;
